import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { completeOnboarding } from '../lib/store';
import { Logo } from '../components/Logo';
const SLIDES = [{
  title: 'Reservá en segundos.',
  desc: 'Agenda tu próximo corte desde cualquier lugar.'
}, {
  title: 'Elegí tu barbero favorito.',
  desc: 'Conocé su experiencia y especialidad.'
}, {
  title: 'Pagá online.',
  desc: 'Confirmación inmediata mediante Mercado Pago.'
}];
export function Onboarding() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const handleNext = () => {
    if (step < SLIDES.length - 1) setStep(s => s + 1);else {
      completeOnboarding();
      navigate('/login');
    }
  };
  return <div className="min-h-screen bg-dark flex justify-center" data-id="element-986">
      <div className="w-full max-w-md bg-dark flex flex-col p-6 text-center relative overflow-hidden" data-id="element-987">
        <div className="flex-1 flex flex-col items-center justify-center" data-id="element-988">
          <AnimatePresence mode="wait" data-id="element-989">
            <motion.div key={step} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="space-y-4" data-id="element-990">
              <Logo emblemOnly size={130} className="mx-auto mb-8" data-id="element-991" />
              <h2 className="text-2xl font-bold text-light" data-id="element-992">
                {SLIDES[step].title}
              </h2>
              <p className="text-light-muted" data-id="element-993">{SLIDES[step].desc}</p>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="pb-8 space-y-8" data-id="element-994">
          <div className="flex justify-center gap-2" data-id="element-995">
            {SLIDES.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all ${i === step ? 'w-6 bg-gold' : 'w-2 bg-white/20'}`} data-id="element-996" />)}
          </div>
          <button onClick={handleNext} className="w-full bg-gold text-dark py-4 rounded-xl font-semibold hover:bg-gold-hover transition-colors" data-id="element-997">
            {step === SLIDES.length - 1 ? 'Comenzar' : 'Siguiente'}
          </button>
        </div>
      </div>
    </div>;
}